<ng-container>
  <div class="ppl-container-body">
    <div class="ppl-container-head">
      <h1 class="page-title-accessibility">Bulk Adjustments</h1>
      @if (!isReadOnly) {
        <div class="action">
          <ppl-button
            label="Add New Adjustment"
            icon="fa fa-plus"
            [customClass]="'primary-button'"
            [iconPosition]="'left'"
            (handleClick)="onAddNewAdjustment()"
          ></ppl-button>
        </div>
      }
    </div>
    <div class="ppl-container">
      <div class="ppl-content-container">
        <div class="table-style">
          @if (programName) {
            <ppl-list-table #massAdjustmentTable
              [pageConfig]="programName"
              [loadPage]="lazyLoad"
              [sharedDataKey]="sharedDataKey"
              [jsonList]="'list_mass_adjustments'"
              [tableWidth]="'100%'"
              [tableScrollable]="true"
              tableScrollHeight="flex"
              [dataLoader]="massAdjustmentsDataLoader"
              [recordsPerPage]="20"
              [enableActions]="!isReadOnly"
              [enablePageActions]="!isReadOnly"
              (rowDetailEvent)="onRowClicked($event)"
               (actionInvoked)="onListAction($event)"
            >
              <ng-template #rowActions let-rowData="rowData">
                <div class="custom-row-actions">
                  <div class="custom-row-actions__container">
                    <ppl-button
                      size="small"
                      [ariaLabel]="'View Results'"
                      label="Results"
                      icon="fa fa-eye"
                      [customClass]="'ghost-button'"
                      [iconPosition]="'left'"
                      [hideLabel]="false"
                      (click)="onViewBatch(rowData?.batchInstanceId, rowData?.batchProcessLKP, rowData?.batchType, rowData?.batchStatus)">
                    </ppl-button>

                    <ppl-button
                      size="small"
                      [ariaLabel]="'View Errors'"
                      label="Errors"
                      icon="fa fa-eye"
                      [customClass]="'ghost-button'"
                      [iconPosition]="'left'"
                      [hideLabel]="false"
                      (click)="onProcessBatch(rowData?.batchInstanceId)">
                    </ppl-button>
                  </div>
                </div>
              </ng-template>
            </ppl-list-table>
          }
        </div>
      </div>
    </div>
  </div>

  <ppl-popup-dialog
    [(isVisible)]="showDeleteDialog"
    [title]="'Delete Bulk Adjustment'"
    [isOkText]="'Delete'"
    [showClose]="false"
    [showButtons]="true"
    [showOkButton]="false"
    [showButtonIcons]="false"
    [hideSaveButton]="false"
    [rightAlignedButtons]="true"
    size="medium"
    position="center"
    (confirm)="confirmDelete()"
    (cancel)="cancelDelete()">
    <div role="region">
      <div class="dialog-content">
        <p>{{ deleteMessage }}</p>
      </div>
    </div>
  </ppl-popup-dialog>

  
</ng-container>
<ppl-popup-dialog
    [(isVisible)]="showGenerateDialog"
    [title]="dialogType === 'approval' ? 'Approve Bulk Adjustment' : dialogType === 'rejection' ? 'Reject Bulk Adjustment' : 'Warning'"
    [showClose]="true"
    [showButtons]="true"
    [showOkButton]="false"
    [hideSaveButton]="dialogType === 'rejection' && (!comments || comments.trim().length === 0)"
    size="medium"
    position="center"
    (confirm)="onConfirm()">

    <div >

      <!-- Warning dialog -->
      <ng-container *ngIf="dialogType === 'warning'">
        <p class="dialog-intro">{{ warningMessage }}</p>
      </ng-container>

      <!-- Approval/Rejection dialog -->
      <ng-container *ngIf="dialogType !== 'warning'">
        <p class="dialog-intro">
          Are you sure you want to {{ dialogType === 'approval' ? 'approve' : 'reject' }} the selected Bulk Adjustment(s)?
        </p>
        <p *ngIf="selectedRows.length > 0">
          <strong>Selected records: {{ selectedRows.length }}</strong>
        </p>
        <div class="comment-section">
          <label [attr.for]="dialogType + 'Comments'">
            <strong>Comments<span *ngIf="dialogType === 'rejection'" style="color: red;"> *</span></strong>
          </label>
          <textarea 
            [id]="dialogType + 'Comments'"
            [(ngModel)]="comments"
            [placeholder]="dialogType === 'approval' ? 'Add comments (optional)' : 'Please provide a reason for rejection (required)'"
            rows="4"
            style="width: 100%; margin-top: 8px; padding: 8px; border: 1px solid #d9d9d9; border-radius: 4px;">
          </textarea>
        </div>
      </ng-container>
    </div>

  </ppl-popup-dialog>
